<template>
  <div>
    <el-dialog
      title="编辑业务人员上级"
      :visible.sync="dialogVisible"
      width="700px"
      :before-close="handleClose"
    >
      <div class="dl-page" style="height: 360px; min-height: 220px">
        <div class="remarks">
          说明：更改业务员上级后，新订单给新上级分成，历史未完结订单仍给旧上级分成
        </div>

        <div class="row v-gap-small">
          <div class="col">
            <div class="row">
              <div class="tip">本级业务员ID：</div>
              <div class="value">
                {{ tableData ? tableData.salesJobNumber : "" }}
              </div>
            </div>
          </div>
          <div class="col">
            <div class="row">
              <div class="tip">本级业务员手机号：</div>
              <div class="value">
                {{ tableData ? tableData.contactInformation : "" }}
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="row">
              <div class="tip">当前上级业务员ID：</div>
              <div class="value">
                {{ tableData ? tableData.sireSalesJobNumber : "" }}
              </div>
            </div>
          </div>
          <div class="col">
            <div class="row">
              <div class="tip">当前上级业务员手机号：</div>
              <div class="value">
                {{ tableData ? tableData.sireContactInformation : "" }}
              </div>
            </div>
          </div>
        </div>
        <div class="row v-gap-small">
          <div class="tip">更改上级业务员：</div>
          <div class="fill-wrap" style="width: 360px">
            <el-select
              :value="displayValue"
              placeholder="请输入业务员ID/业务员手机号/业务员姓名"
              size="small"
              value-key="salesUserId"
              filterable
              remote
              :remote-method="doLoadSales"
              :loading="loading"
              @change="handleChange"
            >
              <el-option
                v-for="item in listData"
                :key="item.salesUserId"
                :label="item.salesUserName"
                :value="item"
              >
                <div class="row">
                  <span style="margin-right: 6px">{{
                    item.salesJobNumber
                  }}</span>
                  <span style="margin-right: 6px">{{
                    item.contactInformation
                  }}</span>
                  <span>{{ item.salesUserName }}</span>
                </div>
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="local_h-line"></div>
        <div class="small-title">认证信息</div>
        <div class="row v-gap">
          <div class="col">
            <div class="row">
              <div class="tip">真实姓名：</div>
              <div class="value">
                {{ tableData ? tableData.salesName : "" || "-" }}
              </div>
            </div>
          </div>
          <div class="col">
            <div class="row">
              <div class="tip">银行卡号：</div>
              <div class="value">
                {{ tableData ? tableData.bankingCard : "" || "-" }}
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="row">
              <div class="tip">认证时间：</div>
              <div class="value">
                {{ tableData ? tableData.authenticationTime : "" || "-" }}
              </div>
            </div>
          </div>
          <div class="col">
            <div class="row">
              <div class="tip">认证状态：</div>
              <div class="value">
                {{ tableData ? tableData.authenticationStatus : "" || "-" }}
              </div>
            </div>
          </div>
        </div>
        <div class="row v-gap button">
          <!-- <el-button type="text" size="small" @click="handleLookDetailRevenue"
            >查看可提现余额</el-button
          > -->
          <el-button
            plain
            size="small"
            type="danger"
            @click="handleLookPayoutsPipeLine"
            >查看已提现余额</el-button
          >
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="right">
          <el-button size="small" @click="handleClose">取 消</el-button>
          <el-button size="small" type="primary" @click="submitUpload()"
            >确认</el-button
          >
        </div>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import MyTable from "@/components/myTable";
import {
  getSalesUserDetailsBySalesIdVO,
  querySalesUserMsg,
  parentSalesUserAlter,
} from "@/api/externalSalesRule/index.js";
import _ from "lodash";

export default {
  components: { MyTable },

  data() {
    return {
      rowData: null,
      displayValue: null,
      listData: [],

      dialogVisible: false,
      tableData: null,

      loading: false,

      selectedParent: null,
    };
  },
  methods: {
    doLoadSales(query) {
      if (query) {
        const params = {
          nameLike: query,
        };
        this.loading = true;
        querySalesUserMsg(params)
          .then((data) => {
            this.loading = false;
            if (data) {
              this.listData = data;
            } else {
              this.listData = [];
            }
          })
          .catch(() => {
            this.loading = false;
            this.listData = [];
          });
      }
    },
    handleLookDetailRevenue() {
      this.$emit("changeTab", {
        row: _.cloneDeep(this.rowData),
        tabindex: "3",
      });
    },
    handleLookPayoutsPipeLine() {
      this.$emit("changeTab", {
        row: _.cloneDeep(this.rowData),
        tabindex: "4",
      });
    },
    handleChange(val) {
      if (val) {
        this.displayValue =
          val.salesJobNumber +
          " " +
          val.contactInformation +
          " " +
          val.salesUserName;

        this.selectedParent = val;
      }
    },
    handleClose() {
      this.dialogVisible = false;
    },
    init() {
      //
    },
    submitUpload() {
      if (!this.selectedParent) {
        this.$message.warning("请选择上级业务员");
        return;
      }
      const data = {
        salesUserId: this.rowData.id,
        parentSalesUserId: this.selectedParent.salesUserId,
      };
      parentSalesUserAlter(data).then((res) => {
        if (res) {
          this.$message.success("更改成功");
          this.dialogVisible = false;
        } else {
          this.$message.error("更改失败");
        }
      });
    },
    getList() {
      const salesUserId = this.rowData.id;

      getSalesUserDetailsBySalesIdVO(salesUserId).then((data) => {
        if (data) {
          this.tableData = data;
        } else {
          this.tableData = null;
        }
      });
    },
    clear() {
      this.rowData = null;
      this.listData = [];
      this.displayValue = "";
      this.selectedParent = null;
      this.tableData = [];
    },
    open(row) {
      this.clear();
      this.dialogVisible = true;

      this.rowData = _.cloneDeep(row);

      this.getList();
    },
  },
};
</script>
<style scoped lang="scss">
@import "../style/index.scss";
.local_h-line {
  width: 100%;
  height: 0;
  border-bottom: 1px solid #f2f2f2;
  background-color: #f2f2f2;
  margin-top: 12px;
  margin-bottom: 12px;
}

.row {
  .tip {
    width: 11em;
    text-align: right;
  }

  &.button {
    padding-left: 60px;
  }
}
</style>
